import React, { useEffect, useState } from 'react';
import { getArticlesByAuthorId, removeOwnArticle, createReview, getAIReviewThemeAndPresentation, isAiActivated, getAIReviewThemeAndPresentationByUser } from '../../HTTP/articles';
import { encodeHTML, formatDateExtended, goToStaticPage, htmlDecode } from '../../Helper/utils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Pagination from '../../Helper/Pagination';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { countries, languages } from '../../global/countriesAndSources';
import CloseIcon from '@mui/icons-material/Close';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import imgArticle from "../../media/ICONS THEMATIQUE/Fichier 5_1.png"
import { removeHtmlTags } from '../../Helper/utils';
import { VISIBILITY_OPTIONS } from '../../Helper/visibilityOptions';

export default function MyArticles() {
  if (localStorage.getItem("subscriptions") === null) {
      window.location.href = '/'
  } else {
    if (JSON.parse(localStorage.getItem("subscriptions")).data === null) {
      window.location.href = '/'
    }
  }
  const url = new URL(window.location.href)
    if (url.searchParams.get('page') === null) {
        url.searchParams.set('page', 1);
        window.history.pushState({}, '', url);
    }
    if (url.searchParams.get('sortby') === null) {
      url.searchParams.set('sortby', 'title');
      window.history.pushState({}, '', url);
  } if (url.searchParams.get('filter') === null) {
    url.searchParams.set('filter', -1);
    window.history.pushState({}, '', url);
}

const [articles, setArticles] = useState({count:0, rows:[]});
const [searchTerm, setSearchTerm] = useState(url.searchParams.get('query') === null ? '' : url.searchParams.get('query'));
const [currentPage, setCurrentPage] = useState(parseInt(url.searchParams.get('page')));
const [itemsPerPage] = useState(10);
const [filter] = useState(url.searchParams.get('filter') === null ? -1 : url.searchParams.get('filter'))
const user = JSON.parse(localStorage.getItem("user"))

// États pour les articles sélectionnés
const [selectedArticles, setSelectedArticles] = useState([]);
const [isCurrentPageAllSelected, setIsCurrentPageAllSelected] = useState(false);
const [hasDraftArticles, setHasDraftArticles] = useState(false);
const [isOneSelected, setIsOneSelected] = useState(false);

// État pour le popup de création de revue de presse
const [showPopup, setShowPopup] = useState(false);
// const [reviews, setReviews] = useState([]);

// Nouveaux états pour les fonctionnalités IA
const [showAIOptions, setShowAIOptions] = useState(false);
const [showAIUserOptions, setShowAIUserOptions] = useState(false);
const [userPrompt, setUserPrompt] = useState("");
const [selectedLanguage, setSelectedLanguage] = useState(sessionStorage.getItem('currentlanguage') || "fr");
const [selectedTone, setSelectedTone] = useState("synthétique");
const [reviewTheme, setReviewTheme] = useState("");
const [reviewPresentation, setReviewPresentation] = useState("");
const [visible, setVisible] = useState(1);
const [isLoading, setIsLoading] = useState(false);
const [aiGenerated, setAiGenerated] = useState(false);
const [aiActivated, setAiActivated] = useState(false);

// Options de ton journalistique
const toneOptions = [
  "synthétique",
  "journalistique",
  "pédagogique",
  "académique",
  "diplomatique",
  "narratif",
  "littéraire",
  "humoristique", 
  "polémique",
  "engagé/militant"
];

useEffect(() => {
  const funArticles = async () => {
    const resArticles = await getArticlesByAuthorId(user.id, (currentPage - 1) * itemsPerPage, currentPage * itemsPerPage, filter, searchTerm)
    setArticles(resArticles)
    
    // Vérifier si tous les articles de la page actuelle sont déjà sélectionnés
    updateCurrentPageSelectionStatus(resArticles.rows, selectedArticles);
  }
  funArticles()
}, [currentPage, searchTerm, filter, itemsPerPage, selectedArticles, user.id]);

// Charger les revues existantes
useEffect(() => {
  const fetchReviews = async () => {
    try {
      // const reviewsData = await userApi.getUserReviews();
      // setReviews(reviewsData.reviews);
    } catch (error) {
      console.log('Erreur lors du chargement des revues de presse', error);
    }
  };
  const fetchIsAiActivated = async () => {
    try {
      const res = await isAiActivated();
      if (res !== undefined) {
        setAiActivated(res.value === '1');
      }
    } catch (error) {
      console.error("Erreur lors de la vérification de l'activation de l'IA:", error);
    }
  }
  fetchIsAiActivated()
  
  fetchReviews();
}, []);

// Vérifier si la liste d'articles sélectionnés contient des brouillons
useEffect(() => {
  // Un article est en brouillon si visible === 0
  const containsDrafts = selectedArticles.some(article => article.visible === 0);
  setHasDraftArticles(containsDrafts);
  if (selectedArticles.length > 0) {
    setIsOneSelected(true);
  }
  else {
    setIsOneSelected(false);
  }
}, [selectedArticles]);

// Mettre à jour le statut de sélection de la page actuelle
const updateCurrentPageSelectionStatus = (currentPageArticles, selectedArticlesList) => {
  if (currentPageArticles.length === 0) {
    setIsCurrentPageAllSelected(false);
    return;
  }
  
  const allCurrentPageSelected = currentPageArticles.every(article => 
    selectedArticlesList.some(selected => selected.id === article.id)
  );
  
  setIsCurrentPageAllSelected(allCurrentPageSelected);
};

const handleSelectedValueOnList = (e) => {
  window.location.href = `/myarticles?page=1&filter=${e.target.value}${searchTerm === '' ? '' : '&query='+searchTerm}`
}

const handleSearch = (e) => {
  e.preventDefault();
  if (url.searchParams.get('query') === null) {
      url.searchParams.set('query', searchTerm);
      window.history.pushState({}, '', url);
  }
  window.location.href = "/myarticles?page=1&query=" + searchTerm
};

const handleAdd = () => {
  window.location.href = "/myarticles/create"
};

const handleEdit = (id) => {
  window.location.href = "/myarticles/edit/" + id
};

const handleViewArticle = (id) => {
  goToStaticPage(true, id);
}

// Gérer la sélection/désélection d'un article
const handleSelectArticle = (article) => {
  setSelectedArticles(prevSelected => {
    // Vérifier si l'article est déjà sélectionné
    const isSelected = prevSelected.some(item => item.id === article.id);
    
    let newSelectedList;
    if (isSelected) {
      // Si déjà sélectionné, on le retire de la liste
      newSelectedList = prevSelected.filter(item => item.id !== article.id);
    } else {
      // Sinon, on l'ajoute à la liste
      newSelectedList = [...prevSelected, article];
    }
    
    // Mettre à jour le statut de sélection pour la page actuelle
    updateCurrentPageSelectionStatus(articles.rows, newSelectedList);
    
    return newSelectedList;
  });
};

// Gérer la sélection/désélection de tous les articles de la page actuelle
const handleSelectAllCurrentPage = () => {
  setSelectedArticles(prevSelected => {
    if (isCurrentPageAllSelected) {
      // Si tous les articles de la page actuelle sont déjà sélectionnés, on les désélectionne
      const newSelectedList = prevSelected.filter(selected => 
        !articles.rows.some(article => article.id === selected.id)
      );
      setIsCurrentPageAllSelected(false);
      return newSelectedList;
    } else {
      // Sinon, on ajoute tous les articles de la page actuelle qui ne sont pas déjà sélectionnés
      const currentPageIds = articles.rows.map(article => article.id);
      
      // Filtrer pour ne garder que les articles qui ne sont pas dans la page actuelle
      const selectedFromOtherPages = prevSelected.filter(
        selected => !currentPageIds.includes(selected.id)
      );
      
      // Ajouter tous les articles de la page actuelle
      const newSelectedList = [...selectedFromOtherPages, ...articles.rows];
      setIsCurrentPageAllSelected(true);
      return newSelectedList;
    }
  });
};

// Fonctions pour les actions en masse
const handleCreatePressReview = () => {
  // Si des brouillons sont présents, cette fonction ne devrait pas être appelée
  if (hasDraftArticles) return;
  
  // Ouvrir le popup pour créer une revue de presse
  setShowPopup(true);
};

const togglePopup = () => {
  setShowPopup(!showPopup);
};

const toggleAIOptions = () => {
    if (showAIUserOptions) setShowAIUserOptions(false);
    setShowAIOptions(!showAIOptions);
  };

  const toggleAIUserOptions = () => {
    if (showAIOptions) setShowAIOptions(false);
    setShowAIUserOptions(!showAIUserOptions);
  };

// Fonction pour générer le contenu avec l'IA
const generateWithAI = async () => {
  // Vérifier si des articles sont sélectionnés
  if (selectedArticles.length === 0) {
    alert("Veuillez sélectionner au moins un article avant de générer du contenu.");
    return;
  }

  // Activer l'indicateur de chargement
  setIsLoading(true);
  
  // Préparer les liens pour l'IA
  const articleLinks = selectedArticles.map(article => 
    `https://static.zemus.info/article/?id=${article.id}`
  );
  
  try {
    // Appel à la fonction d'IA
    const result = await getAIReviewThemeAndPresentation(
      selectedLanguage,
      selectedTone,
      articleLinks,
      user.id
    );
    
    // Si la génération est réussie, remplir les champs
    if (result && result.theme) {
      document.getElementById('review_theme').value = result.theme;
      setReviewTheme(result.theme);
    }
    
    if (result && result.presentation) {
      const presentationValue = result.presentation.join('\n\n');
      document.getElementById('review_presentation').value = presentationValue;
      setReviewPresentation(presentationValue);
    }
    
    // Masquer les options d'IA après avoir généré
    setShowAIOptions(false);

    // Marquer l'indicateur de génération avec l'IA comme vrai
    setAiGenerated(true);
    
  } catch (error) {
    console.error("Erreur lors de la génération avec l'IA:", error);
    alert("Une erreur s'est produite lors de la génération avec l'IA.");
  } finally {
    // Désactiver l'indicateur de chargement quoi qu'il arrive
    setIsLoading(false);
  }
};

const generateWithAIUser = async () => {
    if (selectedArticles.length === 0) {
      alert("Veuillez sélectionner au moins un article avant de générer du contenu.");
      return;
    }
    if (!userPrompt || userPrompt.trim().length === 0) {
      alert("Veuillez saisir un prompt avant de générer.");
      return;
    }

    setIsLoading(true);
    try {
      const articleLinks = selectedArticles.map(item => htmlDecode(item.link));
      const result = await getAIReviewThemeAndPresentationByUser(
        selectedLanguage,
        userPrompt.trim(),
        articleLinks,
        user.id
      );

      if (result?.theme) {
        const themeEl = document.getElementById('review_theme');
        if (themeEl) themeEl.value = result.theme;
        setReviewTheme(result.theme);
      }
      if (result?.presentation) {
        const presentationEl = document.getElementById('review_presentation');
        if (presentationEl) presentationEl.value = result.presentation;
        setReviewPresentation(result.presentation);
      }

      setShowAIUserOptions(false);
      setAiGenerated(true);
    } catch (error) {
      console.error("Erreur lors de la génération avec l'IA (prompt utilisateur):", error);
      alert("Une erreur s'est produite lors de la génération avec l'IA.");
    } finally {
      setIsLoading(false);
    }
  };

const handleAddPressReview = () => {
  const theme = document.getElementById('review_theme').value;
  const presentation = document.getElementById('review_presentation').value;
  const publishable_review = !aiGenerated ? document.getElementById('publishable_review').checked : 0;
  
  // Préparer les données d'articles pour la création de la revue
  const articlesForReview = selectedArticles.map(article => ({
    country: countries.find((c) => c.code === user.country).name,
    description: encodeHTML(article.description).slice(0, 150),
    image: '',
    link: `https://static.zemus.info/article/?id=${article.id}`,
    title: article.title
  }));
  
  createReview(theme, presentation, articlesForReview, publishable_review, visible)
    .then((res) => {
      console.log(res);
      setShowPopup(false);
      alert('Revue de presse créée avec succès');
      goToStaticPage(false, res.newReview);
    })
    .catch(error => {
      console.error("Erreur lors de la création de la revue de presse", error);
      alert("Une erreur est survenue lors de la création de la revue de presse.");
    });
};

const handleAddToPressReview = () => {
  // Si des brouillons sont présents, cette fonction ne devrait pas être appelée
  if (hasDraftArticles) return;

  // Préparer les données pour les articles sélectionnés
  const data = selectedArticles.map(article => ({
    country: countries.find((c) => c.code === user.country).name,
    description: encodeHTML(article.description).slice(0, 150),
    image: '',
    link: `https://static.zemus.info/article/?id=${article.id}`,
    title: article.title
  }));

  // Rediriger vers la page d'ajout à une revue de presse
  window.location.href = `/addtoreview?data=${encodeURIComponent(JSON.stringify(data))}`;
};

const handleAddToFriendPressReview = () => {
  // Si des brouillons sont présents, cette fonction ne devrait pas être appelée
  if (hasDraftArticles) return;

  // Préparer les données pour les articles sélectionnés
  const data = selectedArticles.map(article => ({
    country: countries.find((c) => c.code === user.country).name,
    description: encodeHTML(article.description).slice(0, 150),
    image: '',
    link: `https://static.zemus.info/article/?id=${article.id}`,
    title: article.title
  }));

  // Rediriger vers la page d'ajout à une revue de presse d'un ami
  window.location.href = `/addtofriendreview?data=${encodeURIComponent(JSON.stringify(data))}`;
};

const handleBulkDelete = () => {
  if (window.confirm(`Êtes-vous sûr de vouloir supprimer ${selectedArticles.length} article(s) ?`)) {
    // Ici on pourrait implémenter une suppression en masse via une API
    // Pour l'instant, on supprime séquentiellement chaque article
    let deletePromises = selectedArticles.map(article => removeOwnArticle(article));
    
    Promise.all(deletePromises)
      .then(() => {
        alert("Articles supprimés avec succès !");
        window.location.href = "/myarticles";
      })
      .catch(err => {
        alert("Une erreur est survenue lors de la suppression de certains articles.");
      });
  }
};

// Changer de page
const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);
  url.searchParams.set('page', pageNumber);
  window.history.pushState({}, '', url);
};

const formatVisible = (visible) => {
  switch (visible) {
    case 0: return "Brouillon"
    case 1: return "En ligne"
    case 2: return "En ligne (en cours de vérification)"
    case 3: return "En ligne (vérifié)"
    default: return "-"
  }
}

const canValidate =
  reviewTheme.trim().length > 0 && reviewPresentation.trim().length > 0;

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8">
        {showPopup && (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
            <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4 max-h-[50vh] overflow-y-auto ">
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-xl font-bold text-gray-800">Créer une revue de Presse</h2>
              <button onClick={togglePopup} className="text-gray-500 hover:text-gray-700">
            <CloseIcon />
              </button>
            </div>
            <div className="p-4">
              <div className="mb-4">
            <input
              name="theme"
              placeholder="Thème..."
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              type="text"
              maxLength="255"
              id="review_theme"
              value={reviewTheme}
              onChange={(e) => setReviewTheme(e.target.value)}
            />
              </div>
              <div className="mb-4">
            <textarea
              name="presentation"
              placeholder="Description..."
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={8}
              id="review_presentation"
              value={reviewPresentation}
              onChange={(e) => setReviewPresentation(e.target.value)}
            />
              </div>
              <div className="mb-4 flex items-center">
            <input
              name="publishable_review"
              type="checkbox"
              id="publishable_review"
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="publishable_review" className="ml-2 text-gray-700">
              Autoriser mes amis à publier leurs propres favoris dans cette revue de presse
            </label>
              </div>
            <div className="mb-4 flex flex-col space-y-2 md:flex-row md:space-x-2 md:space-y-0">
            {
              aiActivated && (
                <>
                <button
                  className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                  onClick={toggleAIOptions}
                >
                  {showAIOptions ? "Masquer le résumé" : "Résumer"}
                </button>
                <button
                  className="w-full bg-validbutton hover:bg-validbuttonhover text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
                  onClick={toggleAIUserOptions}
                >
                  {showAIUserOptions ? "Masquer l'analyse" : "Analyser"}
                </button>
                </>
              )
            }

            
              </div>
              {/* Options de l'IA (conditionnellement affichées) */}
                {showAIOptions && (
                  <div className="p-3 border border-gray-300 rounded mt-3 mb-3">
                    <div className="flex flex-col sm:flex-row gap-3 mb-3">
                      <div className="flex-1">
                        <label htmlFor="language-select" className="block text-gray-700 mb-1">
                          Langue:
                        </label>
                        <select
                          id="language-select"
                          className="w-full p-2 rounded border border-gray-300"
                          value={selectedLanguage}
                          onChange={(e) => setSelectedLanguage(e.target.value)}
                          disabled={isLoading}
                        >
                          {languages.map((lang) => (
                            <option key={lang.language_code} value={lang.language_code}>
                              {lang.language_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      
                      <div className="flex-1">
                        <label htmlFor="tone-select" className="block text-gray-700 mb-1">
                          Ton journalistique:
                        </label>
                        <select
                          id="tone-select"
                          className="w-full p-2 rounded border border-gray-300"
                          value={selectedTone}
                          onChange={(e) => setSelectedTone(e.target.value)}
                          disabled={isLoading}
                        >
                          {toneOptions.map((tone) => (
                            <option key={tone} value={tone}>
                              {tone.charAt(0).toUpperCase() + tone.slice(1)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    
                    <button
                      className={`w-full text-white font-bold py-2 px-4 rounded-md flex justify-center items-center ${isLoading ? 'bg-gray-500' : 'bg-green-500 hover:bg-green-600'}`}
                      onClick={generateWithAI}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <div className="flex items-center">
                          <div className="w-5 h-5 mr-2 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
                          Génération en cours...
                        </div>
                      ) : (
                        'Générer'
                      )}
                    </button>
                  </div>
                )}

                { aiActivated && showAIUserOptions && (
                              <div className="ai-options p-3 border border-gray-300 rounded mt-3 mb-3">
                                <div className="flex flex-col sm:flex-row gap-3 mb-3">
                                  <div className="flex-1">
                                    <label htmlFor="language-select-user" className="block text-black mb-1">
                                      Langue :
                                    </label>
                                    <select
                                      id="language-select-user"
                                      className="w-full p-2 rounded border border-black"
                                      value={selectedLanguage}
                                      onChange={(e) => setSelectedLanguage(e.target.value)}
                                      disabled={isLoading}
                                    >
                                      {languages.map((lang) => (
                                        <option key={lang.language_code} value={lang.language_code}>
                                          {lang.language_name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                
                                <div className="mb-3">
                                  <label htmlFor="user-prompt" className="block text-black mb-1">
                                    Prompt :
                                  </label>
                                  <textarea
                                    id="user-prompt"
                                    className="w-full p-2 rounded border border-black"
                                    rows={5}
                                    placeholder="Décrivez précisément le type d'analyse attendu (angle, structure, style, public cible, longueur, etc.)"
                                    value={userPrompt}
                                    onChange={(e) => setUserPrompt(e.target.value)}
                                    disabled={isLoading}
                                  />
                                </div>
                
                                <button
                                  className={`text-white font-bold py-2 px-5 rounded w-full flex justify-center items-center ${isLoading ? 'bg-gray-500' : 'bg-green-500 hover:bg-green-700'}`}
                                  onClick={generateWithAIUser}
                                  disabled={isLoading}
                                >
                                  {isLoading ? (
                                    <div className="flex items-center">
                                      <div className="animate-spin h-5 w-5 mr-2 border-t-2 border-b-2 border-white rounded-full"></div>
                                      Génération en cours...
                                    </div>
                                  ) : (
                                    'Générer'
                                  )}
                                </button>
                              </div>
                            )}
                
                {/* Indicateur de chargement global sur la popup */}
                {isLoading && (
                  <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                    <div className="bg-white p-5 rounded-lg shadow-lg flex flex-col items-center">
                      <div className="w-12 h-12 border-4 border-t-4 border-gray-200 rounded-full animate-spin mb-3" style={{ borderTopColor: '#3B82F6' }}></div>
                      <p className="text-gray-700 font-medium">Génération en cours...</p>
                      <p className="text-gray-500 text-sm mt-1">Cela peut prendre un moment</p>
                    </div>
                  </div>
                )}
                {selectedArticles.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-4">
                    {selectedArticles.map((article, i) => (
                      <div key={i} className="bg-gray-100 rounded-md p-2 text-sm">
                        {article.title.substring(0, 30)}{article.title.length > 30 ? '...' : ''}
                      </div>
                    ))}
                  </div>
                )}
                <div className="ml-4 mb-4">
              <label htmlFor="visible" className="text-black">
                Visibilité de la revue de presse :
              </label>
              <select id="visible" className="ml-2 p-1 rounded" value={visible} onChange={(e) => setVisible(parseInt(e.target.value))}>
                {VISIBILITY_OPTIONS.map((option) => (
                  <option value={option.value} key={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
              <button
              className={`w-full bg-profileheader hover:bg-validbuttonhover text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50 mt-2 ${
                isLoading || !canValidate ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handleAddPressReview}
              disabled={isLoading || !canValidate}
            >
              Valider
            </button>
            </div>
            </div>
          </div>
        </>
      )}

      <div className="flex items-center justify-between mt-10 mb:mt-0 mb-4">
        <h1 className="text-2xl font-bold text-center flex-grow">
          Mes articles
        </h1>
      </div>
      <form onSubmit={handleSearch} className="w-full mb-4">
        <div className="flex flex-col space-y-3 lg:flex-row lg:space-y-0 lg:space-x-3">
          {/* Container principal qui prend toute la largeur disponible */}
          <div className="flex-1 flex space-x-2">
            <input
              type="text"
              placeholder="Rechercher..."
              className="flex-1 px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 focus:outline-none"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              type="submit"
              className="px-4 py-2.5 bg-zemusbis text-white rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            >
              <SearchIcon />
            </button>
            <button
              type="button"
              className="px-4 py-2.5 bg-zemushover text-white rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
              onClick={handleAdd}
            >
              <AddIcon color='disabled' />
            </button>
          </div>

          {/* Select avec une largeur fixe */}
          <select 
            value={filter} 
            onChange={handleSelectedValueOnList}
            className="w-full lg:w-48 px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm bg-white transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 focus:outline-none appearance-none"
            name="visibility"
          >
            <option value={-1}>Tous les articles</option>
            {VISIBILITY_OPTIONS.map((option) => (
              <option value={option.value} key={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
      </form>

      {/* Affichage des actions pour les articles sélectionnés */}
        <div className="mb-4 p-3 bg-blue-100 rounded-lg">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-blue-800 font-medium">{selectedArticles.length} article(s) sélectionné(s)</p>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={handleCreatePressReview}
                disabled={hasDraftArticles || !isOneSelected}
                className={`px-3 py-1.5 text-white text-sm rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 ${
                  hasDraftArticles || !isOneSelected 
                    ? 'bg-[#78b5bc] cursor-not-allowed' 
                    : 'bg-[#009AAD] hover:bg-[#009AAD]'
                }`}
                title={hasDraftArticles ? "Impossible de créer une revue de presse avec des brouillons" : ""}
              >
                <span className="hidden lg:inline">Publier</span>
                <span className="lg:hidden">
                  <AddIcon fontSize="medium" />
                </span>
              </button>
              <button
                onClick={handleAddToPressReview}
                disabled={hasDraftArticles || !isOneSelected}
                className={`px-3 py-1.5 text-white text-sm rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 ${
                  hasDraftArticles || !isOneSelected 
                    ? 'bg-[#78b5bc] cursor-not-allowed' 
                    : 'bg-[#009AAD] hover:bg-[#009AAD]'
                }`}
                title={hasDraftArticles ? "Impossible d'ajouter des brouillons à une revue de presse" : ""}
              >
                <span className="hidden lg:inline">Republier</span>
                <span className="lg:hidden">
                  <PlaylistAddIcon fontSize="medium" />
                </span>
              </button>
              <button
                onClick={handleAddToFriendPressReview}
                disabled={hasDraftArticles || !isOneSelected}
                className={`px-3 py-1.5 text-white text-sm rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 ${
                  hasDraftArticles || !isOneSelected 
                    ? 'bg-[#78b5bc] cursor-not-allowed' 
                    : 'bg-[#009AAD] hover:bg-[#009AAD]'
                }`}
                title={hasDraftArticles ? "Impossible d'ajouter des brouillons à une revue de presse" : ""}
              >
                <span className="hidden lg:inline">Co-publier</span>
                <span className="lg:hidden">
                  <PersonAddIcon fontSize="medium" />
                </span>
              </button>
              <button
                onClick={handleBulkDelete}
                disabled={!isOneSelected}
                className={`px-3 py-1.5 text-white text-sm rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 ${!isOneSelected ? 'cursor-not-allowed bg-red-300' : 'bg-red-500 hover:bg-red-600'}`}
              >
                <span className="hidden lg:inline">Supprimer</span>
                <span className="lg:hidden">
                  <DeleteIcon fontSize="medium" />
                </span>
              </button>
            </div>
          </div>
          {hasDraftArticles && (
            <p className="mt-2 text-red-600 text-sm">
              Certains articles sélectionnés sont des brouillons. Ils ne peuvent pas être utilisés pour créer ou être ajoutés à une revue de presse.
            </p>
          )}
          {
            !isOneSelected && (
              <p className="mt-2 text-red-600 text-sm">
                Aucun article sélectionné. Veuillez sélectionner au moins un article pour effectuer des actions.
              </p>
            )
          }
        </div>
          <input 
            type="checkbox" 
            checked={isCurrentPageAllSelected && articles.rows.length > 0}
            onChange={handleSelectAllCurrentPage}
            className="h-4 w-4 mb-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label className="ml-2 text-gray-700 font-medium">Sélectionner tout</label>
      <div className={`max-h-[50vh] overflow-y-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ml-4 mr-4`}>

            {articles.rows.map((item, index) => (
              <div className="bg-white rounded-lg shadow-md overflow-hidden transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl mb-4" key={item.id}>
                <div className="flex flex-col h-full">
                <button onClick={() => handleViewArticle(item.id)}>
                  <img
                    className="w-full h-48 object-cover flex-shrink-0"
                    src={item.featured_image === null ? imgArticle : item.featured_image}
                    alt={item.title}
                  />
                </button>
                  <div className="p-4 flex-grow flex flex-col">
                    <button onClick={() => handleViewArticle(item.id)}>
                      <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                      <p className="text-gray-600 flex-grow">
                        {removeHtmlTags(item.description).length > 150 ? removeHtmlTags(item.description).slice(0, 50) + "..." : removeHtmlTags(item.description)}
                      </p>
                    </button>
                    <div className="flex items-center mb-2">
                      <input 
                        type="checkbox" 
                        checked={selectedArticles.some(article => article.id === item.id)}
                        onChange={() => handleSelectArticle(item)}
                        className="h-4 mr-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <button className="bg-validbutton hover:bg-validbuttonhover text-white font-bold rounded mr-1 p-1" onClick={() => handleViewArticle(item.id)}>
                        <VisibilityIcon />
                      </button>
                      <button 
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold rounded mr-1 p-1"
                        onClick={() => handleEdit(item.id)}
                      >
                        <EditIcon />
                      </button>
                      <p className="text-sm mt-2 ml-2 notranslate">
                        {formatDateExtended(item.updated_at)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              // <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              //   {/* Cellule avec la case à cocher pour la sélection */}
              //   <td className="px-4 py-4">
              //     <input 
              //       type="checkbox" 
              //       checked={selectedArticles.some(article => article.id === item.id)}
              //       onChange={() => handleSelectArticle(item)}
              //       className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              //     />
              //   </td>
              //   <td className="px-4 py-4 break-words">
              //     <div className="max-w-xs lg:max-w-sm xl:max-w-md">{item.title}</div>
              //   </td>
              //   <td className="hidden lg:table-cell px-4 py-4">{formatDateExtended(item.created_at)}</td>
              //   <td className="hidden xl:table-cell px-4 py-4">{formatDateExtended(item.updated_at)}</td>
              //   <td className="px-4 py-4">{formatVisible(item.visible)}</td>
              //   <td className="px-4 py-4 whitespace-nowrap overflow-x-auto">
              //   <button className="bg-green-500 hover:bg-green-700 text-white font-bold rounded mr-1 p-1" onClick={() => handleViewArticle(item.id)}>
              //   <VisibilityIcon />
              //   </button>
              //     <button 
              //       className="bg-blue-500 hover:bg-blue-700 text-white font-bold rounded mr-1 p-1"
              //       onClick={() => handleEdit(item.id)}
              //     >
              //       <EditIcon />
              //     </button>
              //     {/* <button 
              //       className="bg-red-500 hover:bg-red-700 text-white font-bold rounded mr-1 p-1"
              //       onClick={() => {
              //         if (window.confirm("Are you sure you want to delete this item ?")) {
              //           handleDelete(item);
              //         }
              //       }}
              //     >
              //       <DeleteIcon />
              //     </button> */}
              //   </td>
              // </tr>
            ))}
      </div>
      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={articles.count}
        paginate={paginate}
        currentPage={currentPage}
      />
      
    </div>
  );
}
